import Dashboard from '../index';
import Type1 from '../Type1';
// import Type2 from "../Type2";
import Type3 from '../Type3';
import Type4 from '../Type4';
// import Type5 from '../Type5';
// import Type6 from '../Type6';
import Type7 from '../Type7';
import Type8 from '../Type8';
import Type9 from '../Type9';
// import Type9a from "../Type9a";
import Type10 from '../Type10';
import Type10A from '../Type10A';
import Type11 from '../Type11';
import Type12 from '../Type12';
import Type13 from '../Type13';
// import Type14 from '../Type14';
import Type15 from '../Type15';
// import Type16 from '../Type16';
import Type17 from '../Type17';
import Type18 from '../Type18';
import Type19 from '../Type19';
import Type20 from '../Type20';
import Type20A from '../Type20A';
import Type23 from '../Type23';
import Type27 from '../Type27';
import Type28 from '../Type28';
import Type22 from '../Type22';
import Type24 from '../Type24';
import Type24A from '../Type24A';
import Type25 from '../Type25';
import Type29 from '../Type29';
import Type30 from '../Type30';
import Type30A from '../Type30A';
import Type31 from '../Type31';
import Type32 from '../Type32';
import Type33 from '../Type33';
import Type34 from '../Type34';
import Type35 from '../Type35';
import Type35A from '../Type35A';
import Type36 from '../Type36';
import Type37 from '../Type37';
import Type38 from '../Type38';
import Type39 from '../Type39';
import Type40 from '../Type40';
import Type41 from '../Type41';
import Type42 from '../Type42';
import Type42A from '../Type42A';
import Type43 from '../Type43';
import Type43A from '../Type43A';
import Type44 from '../Type44';
import Type44A from '../Type44A';
import Type45 from '../Type45';
import Type46 from '../Type46';
import Type47 from '../Type47';
import Type48 from '../Type48';
import Type48A from '../Type48A';
import Type49 from '../Type49';
import Type50 from '../Type50';
import Type50A from '../Type50A';
import Type51 from '../Type51';
import Type52 from '../Type52';
import Type53 from '../Type53';
import Type54 from '../Type54';
import Type55 from '../Type55';
import Type56 from '../Type56';
import Type57 from '../Type57';
import Type57A from '../Type57A';
import Type58 from '../Type58';
import Type61 from '../Type61';
import Type62 from '../Type62';
import Type63 from '../Type63';
import Type64 from '../Type64';
import Type65 from '../Type65';
import Type67 from '../Type67';
import Type68 from '../Type68';
import Type69 from '../Type69';
import Type70 from '../Type70';
import Type70A from '../Type70A';
import Type71 from '../Type71';
import Type71A from '../Type71A';
import Type72 from '../Type72';
import Type72A from '../Type72A';
import Type72B from '../Type72B';
import Type73 from '../Type73';
import Type74 from '../Type74';
import Type75 from '../Type75';
import Type76 from '../Type76';
import Type77 from '../Type77';
import Type78 from '../Type78';
import Type79 from '../Type79';
import Type80 from '../Type80';
import Type81 from '../Type81';
import Type82 from '../Type82';
import Type83 from '../Type83';
import Type84 from '../Type84';
import Type85 from '../Type85';
import Type86 from '../Type86';
import Type87 from '../Type87';
import Type88 from '../Type88';
import Type89 from '../Type89';
import Type90 from '../Type90';
import Type91 from '../Type91';
import Type92 from '../Type92';
import Type93 from '../Type93';
import Type94 from '../Type94';
import Type95 from '../Type95';
import Type96 from '../Type96';
import Type97 from '../Type97';
import Type98 from '../Type98';
import Type99 from '../Type99';
import Type100 from '../Type100';
import Type101 from '../Type101';
import Type102 from '../Type102';
import Type103 from '../Type103';
import Type104 from '../Type104';
import Type105 from '../Type105';
import Type106 from '../Type106';
import Type107 from '../Type107';
import Type111 from '../Type111';
import Type112 from '../Type112';
import Type115 from '../Type115';
import Type116 from '../Type116';
// import Type117 from '../Type117';
import Type118 from '../Type118';
import Type120 from '../Type120';
import Type119 from '../Type119';
import Type121 from '../Type121';
import Type122 from '../Type122';
import Type123 from '../Type123';
import Type113 from '../Type113';
import Type126 from '../Type126';
import Type128 from '../Type128';
import Type129 from '../Type129';
import Type130 from '../Type130';
import Type130A from '../Type130A';
import Type131 from '../Type131';
import Type132 from '../Type132';

const routes = [
  {
    path: '/dashboard',
    name: 'Trang Chủ',
    miniName: 'D',
    component: Dashboard,
    icon: 'fas fa-home text-info',
    layout: '/olympicsgk',
    exact: true,
  },
  {
    path: '/type1',
    name: 'Type 1',
    miniName: 'Type',
    component: Type1,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  // {
  //   path: "/type2",
  //   name: "Type 2",
  //   miniName: "B",
  //   component: Type2,
  //   layout: "/olympicsgk",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },

  {
    path: '/type3',
    name: 'Type 3',
    miniName: 'B',
    component: Type3,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/type4',
    name: 'Type 4',
    miniName: 'B',
    component: Type4,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  // {
  //   path: '/type5',
  //   name: 'Type 5',
  //   miniName: 'B',
  //   component: Type5,
  //   layout: '/olympicsgk',
  //   icon: 'fas fa-book text-yellow',
  //   exact: true,
  // },
  // {
  //   path: '/type6',
  //   name: 'Type 6',
  //   miniName: 'B',
  //   component: Type6,
  //   layout: '/olympicsgk',
  //   icon: 'fas fa-book text-yellow',
  //   exact: true,
  // },

  {
    path: '/type7',
    name: 'Type 7',
    miniName: 'B',
    component: Type7,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/type8',
    name: 'Type 8',
    miniName: 'B',
    component: Type8,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/type9',
    name: 'Type 9',
    miniName: 'B',
    component: Type9,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  // {
  //   path: "/type9a",
  //   name: "Type 9a",
  //   miniName: "B",
  //   component: Type9a,
  //   layout: "/olympicsgk",
  //   icon: "fas fa-book text-yellow",
  //   exact: true,
  // },

  {
    path: '/type10',
    name: 'Type 10',
    miniName: 'B',
    component: Type10,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type10A',
    name: 'Type 10A',
    miniName: 'B',
    component: Type10A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/type11',
    name: 'Type 11',
    miniName: 'B',
    component: Type11,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/type12',
    name: 'Type 12',
    miniName: 'B',
    component: Type12,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/type13',
    name: 'Type 13',
    miniName: 'B',
    component: Type13,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  // {
  //   path: '/type14',
  //   name: 'Type 14',
  //   miniName: 'B',
  //   component: Type14,
  //   layout: '/olympicsgk',
  //   icon: 'fas fa-book text-yellow',
  //   exact: true,
  // },
  {
    path: '/type15',
    name: 'Type 15',
    miniName: 'B',
    component: Type15,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  // {
  //   path: '/type16',
  //   name: 'Type 16',
  //   miniName: 'B',
  //   component: Type16,
  //   layout: '/olympicsgk',
  //   icon: 'fas fa-book text-yellow',
  //   exact: true,
  // },
  {
    path: '/type17',
    name: 'Type 17',
    miniName: 'B',
    component: Type17,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type18',
    name: 'Type 18',
    miniName: 'B',
    component: Type18,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type19',
    name: 'Type 19',
    miniName: 'B',
    component: Type19,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type20',
    name: 'Type 20',
    miniName: 'B',
    component: Type20,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type20A',
    name: 'Type 20A',
    miniName: 'B',
    component: Type20A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type22',
    name: 'Type 22',
    miniName: 'B',
    component: Type22,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type23',
    name: 'Type 23',
    miniName: 'B',
    component: Type23,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type24',
    name: 'Type 24',
    miniName: 'B',
    component: Type24,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type24A',
    name: 'Type 24A',
    miniName: 'B',
    component: Type24A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type25',
    name: 'Type 25',
    miniName: 'B',
    component: Type25,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type27',
    name: 'Type 27',
    miniName: 'B',
    component: Type27,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type28',
    name: 'Type 28',
    miniName: 'B',
    component: Type28,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/type29',
    name: 'Type 29',
    miniName: 'B',
    component: Type29,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/type30',
    name: 'Type 30',
    miniName: 'B',
    component: Type30,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/type30A',
    name: 'Type 30A',
    miniName: 'B',
    component: Type30A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/type31',
    name: 'Type 31',
    miniName: 'B',
    component: Type31,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/Type32',
    name: 'Type 32',
    miniName: 'B',
    component: Type32,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/Type33',
    name: 'Type 33',
    miniName: 'B',
    component: Type33,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type34',
    name: 'Type 34',
    miniName: 'B',
    component: Type34,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type35',
    name: 'Type 35',
    miniName: 'B',
    component: Type35,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type35A',
    name: 'Type 35A',
    miniName: 'B',
    component: Type35A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type36',
    name: 'Type 36',
    miniName: 'B',
    component: Type36,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type37',
    name: 'Type 37',
    miniName: 'B',
    component: Type37,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type38',
    name: 'Type 38',
    miniName: 'B',
    component: Type38,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type39',
    name: 'Type 39',
    miniName: 'B',
    component: Type39,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type40',
    name: 'Type 40',
    miniName: 'B',
    component: Type40,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  }, {
    path: '/Type41',
    name: 'Type 41',
    miniName: 'B',
    component: Type41,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/Type42',
    name: 'Type 42',
    miniName: 'B',
    component: Type42,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type42A',
    name: 'Type 42A',
    miniName: 'B',
    component: Type42A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/Type43',
    name: 'Type 43',
    miniName: 'B',
    component: Type43,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type43A',
    name: 'Type 43A',
    miniName: 'B',
    component: Type43A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },

  {
    path: '/Type44',
    name: 'Type 44',
    miniName: 'B',
    component: Type44,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type44A',
    name: 'Type 44A',
    miniName: 'B',
    component: Type44A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type45',
    name: 'Type 45',
    miniName: 'B',
    component: Type45,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type46',
    name: 'Type 46',
    miniName: 'B',
    component: Type46,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type47',
    name: 'Type 47',
    miniName: 'B',
    component: Type47,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type48',
    name: 'Type 48',
    miniName: 'B',
    component: Type48,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type48A',
    name: 'Type 48A',
    miniName: 'B',
    component: Type48A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type49',
    name: 'Type 49',
    miniName: 'B',
    component: Type49,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type50',
    name: 'Type 50',
    miniName: 'B',
    component: Type50,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type50A',
    name: 'Type 50A',
    miniName: 'B',
    component: Type50A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type51',
    name: 'Type 51',
    miniName: 'B',
    component: Type51,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type52',
    name: 'Type 52',
    miniName: 'B',
    component: Type52,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type53',
    name: 'Type 53',
    miniName: 'B',
    component: Type53,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type54',
    name: 'Type 54',
    miniName: 'B',
    component: Type54,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type55',
    name: 'Type 55',
    miniName: 'B',
    component: Type55,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type56',
    name: 'Type 56',
    miniName: 'B',
    component: Type56,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type57',
    name: 'Type 57',
    miniName: 'B',
    component: Type57,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type57A',
    name: 'Type 57A',
    miniName: 'B',
    component: Type57A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type58',
    name: 'Type 58',
    miniName: 'B',
    component: Type58,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type61',
    name: 'Type 61',
    miniName: 'B',
    component: Type61,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type62',
    name: 'Type 62',
    miniName: 'B',
    component: Type62,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type63',
    name: 'Type 63',
    miniName: 'B',
    component: Type63,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type64',
    name: 'Type 64',
    miniName: 'B',
    component: Type64,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type65',
    name: 'Type 65',
    miniName: 'B',
    component: Type65,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type67',
    name: 'Type 67',
    miniName: 'B',
    component: Type67,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type68',
    name: 'Type 68',
    miniName: 'B',
    component: Type68,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type69',
    name: 'Type 69',
    miniName: 'B',
    component: Type69,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type70',
    name: 'Type 70',
    miniName: 'B',
    component: Type70,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type70A',
    name: 'Type 70A',
    miniName: 'B',
    component: Type70A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type71',
    name: 'Type 71',
    miniName: 'B',
    component: Type71,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type71A',
    name: 'Type 71A',
    miniName: 'B',
    component: Type71A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type72',
    name: 'Type 72',
    miniName: 'B',
    component: Type72,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type72A',
    name: 'Type 72A',
    miniName: 'B',
    component: Type72A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type72B',
    name: 'Type 72B',
    miniName: 'B',
    component: Type72B,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type73',
    name: 'Type 73',
    miniName: 'B',
    component: Type73,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type74',
    name: 'Type 74',
    miniName: 'B',
    component: Type74,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type75',
    name: 'Type 75',
    miniName: 'B',
    component: Type75,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type76',
    name: 'Type 76',
    miniName: 'B',
    component: Type76,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type77',
    name: 'Type 77',
    miniName: 'B',
    component: Type77,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type78',
    name: 'Type 78',
    miniName: 'B',
    component: Type78,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type79',
    name: 'Type 79',
    miniName: 'B',
    component: Type79,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type80',
    name: 'Type 80',
    miniName: 'B',
    component: Type80,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type81',
    name: 'Type 81',
    miniName: 'B',
    component: Type81,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type82',
    name: 'Type 82',
    miniName: 'B',
    component: Type82,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type83',
    name: 'Type 83',
    miniName: 'B',
    component: Type83,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type84',
    name: 'Type 84',
    miniName: 'B',
    component: Type84,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type85',
    name: 'Type 85',
    miniName: 'B',
    component: Type85,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type86',
    name: 'Type 86',
    miniName: 'B',
    component: Type86,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type87',
    name: 'Type 87',
    miniName: 'B',
    component: Type87,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type88',
    name: 'Type 88',
    miniName: 'B',
    component: Type88,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type89',
    name: 'Type 89',
    miniName: 'B',
    component: Type89,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type90',
    name: 'Type 90',
    miniName: 'B',
    component: Type90,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type91',
    name: 'Type 91',
    miniName: 'B',
    component: Type91,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type92',
    name: 'Type 92',
    miniName: 'B',
    component: Type92,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type93',
    name: 'Type 93',
    miniName: 'B',
    component: Type93,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type94',
    name: 'Type 94',
    miniName: 'B',
    component: Type94,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type95',
    name: 'Type 95',
    miniName: 'B',
    component: Type95,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type96',
    name: 'Type 96',
    miniName: 'B',
    component: Type96,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type97',
    name: 'Type 97',
    miniName: 'B',
    component: Type97,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type98',
    name: 'Type 98',
    miniName: 'B',
    component: Type98,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type99',
    name: 'Type 99',
    miniName: 'B',
    component: Type99,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type100',
    name: 'Type 100',
    miniName: 'B',
    component: Type100,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type101',
    name: 'Type 101',
    miniName: 'B',
    component: Type101,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type102',
    name: 'Type 102',
    miniName: 'B',
    component: Type102,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type103',
    name: 'Type 103',
    miniName: 'B',
    component: Type103,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type104',
    name: 'Type 104',
    miniName: 'B',
    component: Type104,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type105',
    name: 'Type 105',
    miniName: 'B',
    component: Type105,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type106',
    name: 'Type 106',
    miniName: 'B',
    component: Type106,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type107',
    name: 'Type 107',
    miniName: 'B',
    component: Type107,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type111',
    name: 'Type 111',
    miniName: 'B',
    component: Type111,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type112',
    name: 'Type 112',
    miniName: 'B',
    component: Type112,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type113',
    name: 'Type 113',
    miniName: 'B',
    component: Type113,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type115',
    name: 'Type 115',
    miniName: 'B',
    component: Type115,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type116',
    name: 'Type 116',
    miniName: 'B',
    component: Type116,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  // {
  //   path: '/Type117',
  //   name: 'Type 117',
  //   miniName: 'B',
  //   component: Type117,
  //   layout: '/olympicsgk',
  //   icon: 'fas fa-book text-yellow',
  //   exact: true,
  // },
  {
    path: '/Type118',
    name: 'Type 118',
    miniName: 'B',
    component: Type118,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type119',
    name: 'Type 119',
    miniName: 'B',
    component: Type119,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type120',
    name: 'Type 120',
    miniName: 'B',
    component: Type120,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type121',
    name: 'Type 121',
    miniName: 'B',
    component: Type121,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type122',
    name: 'Type 122',
    miniName: 'B',
    component: Type122,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type123',
    name: 'Type 123',
    miniName: 'B',
    component: Type123,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type126',
    name: 'Type 126',
    miniName: 'B',
    component: Type126,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type128',
    name: 'Type 128',
    miniName: 'B',
    component: Type128,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type129',
    name: 'Type 129',
    miniName: 'B',
    component: Type129,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type130',
    name: 'Type 130',
    miniName: 'B',
    component: Type130,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type130A',
    name: 'Type 130A',
    miniName: 'B',
    component: Type130A,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type131',
    name: 'Type 131',
    miniName: 'B',
    component: Type131,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
  {
    path: '/Type132',
    name: 'Type 132',
    miniName: 'B',
    component: Type132,
    layout: '/olympicsgk',
    icon: 'fas fa-book text-yellow',
    exact: true,
  },
];

export default routes;
